import { render, staticRenderFns } from "./RequireKitting.vue?vue&type=template&id=05d73508"
import script from "./RequireKitting.vue?vue&type=script&lang=js"
export * from "./RequireKitting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports